export const useIpDataStore = defineStore('ipData', {
  state: () => ({
    ipData: null,
  }),
  actions: {
    async fetch(ipAddress, token) {
      ipAddress = ['127.0.0.1', 'localhost'].includes(ipAddress)
        ? ''
        : ipAddress;
      try {
        const ipData = await $fetch(
          `https://pro.ip-api.com/json/${ipAddress || ''}?key=${token}`
        );
        this.setData(ipData);
      } catch (error) {
        console.error('Error fetching IP data:', error);
        this.setData(null);
      }
    },
    setData(ipData) {
      this.ipData = ipData;
    },
  },
  getters: {
    countryCode: (state) => state.ipData?.country,
  },
});
